const createElementFromHTML = (htmlString) => {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
};
const createGrisLoader = () => {
  const container = document.createElement('div');
  container.classList.add('grisLoader');
  /*const squareOne = document.createElement('div');
  squareOne.className = 'square one';
  const squareTwo = document.createElement('div');
  squareTwo.className = 'square two';
  const squareThree = document.createElement('div');
  squareThree.className = 'square three';
  const loadingText = document.createElement('p');
  loadingText.className = 'loadingText';
  loadingText.innerHTML = 'RWI';
  squareThree.append(loadingText);
  container.append(squareOne, squareTwo, squareThree);*/

  document.body.append(container);
};

const initAjaxPagination = (pagination) => {
  if (pagination) {
    const paginationLinks = pagination.querySelectorAll('a');
    if (paginationLinks) {
      paginationLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          makeGrisRequest(link.getAttribute('data-ajaxuri'));
        });
      });
    }
  }
};
const makeGrisRequest = ($url, $async = true) => {
  const xhr = new XMLHttpRequest();
  const loader = () => document.getElementsByClassName('grisLoader');
  if (loader().length < 1) {
    createGrisLoader();
  }
  xhr.onreadystatechange = function() { // Call a function when the state changes.
    if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
      document.querySelector('.rwi_gris').
          replaceWith(createElementFromHTML(this.response));
      loader()[0].classList.remove('loading');
      const pagination = document.querySelector('.rwi_gris .pagination');
      initAjaxPagination(pagination);
    }
    else if (loader() && !loader()[0].classList.contains('loading')) {
      loader()[0].classList.add('loading');
    }
  };
  xhr.open('GET', $url, $async);
  document.querySelector('.rwi_gris').scrollIntoView();
  xhr.send();
};

const mainGrisInit = () => {
  const gris = document.querySelector('.rwi_gris');
  createGrisLoader();

  if (gris) {
    const pagination = gris.querySelector('.pagination');
    if (pagination) {
      initAjaxPagination(pagination);
    }
  }
};

if (
    document.readyState === 'complete'
    || (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
}
else {
  mainGrisInit();
}
